import './kitStyles';
import React from 'react';
import { ICONS, ICONS_SM, parseShapes, type IconName, type IconShape } from './icons';

/**
 * WEB-3310 юнит 1 — значок кита, эталон `Icon({ name, size = 16 })`
 * (`design/cabinet-rescin/kit.jsx`): окно 21 вместо 24 (рисунок крупнее на 14 %),
 * толщина линии по размеру × 0,875 и она же — `--sw` в стиле (знак системных
 * значков `.g`/`.gd` толще от неё, правило в `styles/cabinet-kit-1.css`); до 16
 * включительно системные берут мелкий рисунок. Скрыт от диктора: подпись даёт
 * хозяин значка.
 */
export interface IconProps {
  name: IconName;
  size?: number;
}

function shape(s: IconShape, key: number): React.ReactElement | null {
  if (s.kind === 'path') return <path key={key} d={s.d} className={s.className} />;
  if (s.kind === 'circle')
    return <circle key={key} cx={s.cx} cy={s.cy} r={s.r} fill={s.fill} />;
  if (s.kind === 'rect')
    return (
      <rect key={key} x={s.x} y={s.y} width={s.width} height={s.height} rx={s.rx} />
    );
  return null;
}

export function Icon({ name, size = 16 }: IconProps): React.ReactElement {
  const sw = (size <= 14 ? 1.75 : size <= 18 ? 1.6 : size <= 26 ? 1.4 : 1.1) * 0.875;
  const shapes = parseShapes((size <= 16 && ICONS_SM[name]) || ICONS[name]);
  const group = shapes[0].kind === 'group' ? shapes[0] : null;
  const body = shapes.map(shape);
  return (
    <svg
      className="ico"
      width={size}
      height={size}
      viewBox="1.5 1.5 21 21"
      fill="none"
      stroke="currentColor"
      strokeWidth={sw}
      style={{ '--sw': sw } as React.CSSProperties}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {group ? <g transform={group.transform}>{body}</g> : body}
    </svg>
  );
}
